<template>
  <v-card class="mx-auto" max-width="100%" tile>
    <v-navigation-drawer v-model="drawer" app color="">
      <v-list-item class="ml-3 mb-2 mt-2">
        <a href="/">
        <v-img src="../assets/logo.png" width="110px" height="50px"></v-img>
      </a>
        <v-list-item-content>
          <v-list-item-subtitle> </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-subheader><h3 class="ml-12">CATEGORIAS</h3> </v-subheader>

        <div v-for="category in listCategory" :key="category.id">
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class=" "
                  ><h3 style="min-height: 25px;">
                    <v-btn icon>
                      <v-icon size="20">
                        {{ category.dataCategory.icon }}</v-icon
                      >
                    </v-btn>
                    {{ category.dataCategory.name }}
                  </h3></v-list-item-title
                >
              </v-list-item-content>
            </template>

            <div
              v-for="subCategory in category.resultsDataSubCategory"
              :key="subCategory.id"
            >
              <v-list-item link @click="selectCategory(subCategory)">
                <v-list-item-content>
                  <v-list-item-titles class="subtitle-1 ml-6">
                    <v-icon color="primary" size="15">mdi-chevron-right</v-icon>
                    {{ subCategory.name }}</v-list-item-titles
                  >
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list-group>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="#FFF" dark>
      <v-app-bar-nav-icon
        size="30"
        @click.stop="drawer = !drawer"
        color="black darken-2"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <div class="flex-grow-1"></div>
      <Account />
      <Cart></Cart>
    </v-app-bar>

    <main class="main">
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </main>

    <confirm ref="confirm"></confirm>
    <Alert ref="Alert"></Alert>
  </v-card>
</template>
<script>
import confirm from "@/components/Reusable/Confirm.vue";
import Alert from "@/components/Reusable/Alert.vue";
import Cart from "./Cart.vue";
import Account from "./Account.vue";

export default {
  name: "MainViewComponent",
  components: {
    confirm,
    Alert,
    Cart,
    Account,
  },
  data: () => ({
    drawer: true,
    listCategory: [],
  }),
  created() {},
  computed: {},
  methods: {
    selectCategory(subCategory) {
      this.$router.push("/product");
      this.$store
        .dispatch("updateCategory", subCategory)
        .then((response) => {})
        .catch((error) => {});
    },
    loadCategory() {
      this.$axios
        .get("/api/category-menu")
        .then((res) => {
          this.listCategory = res.data.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
  },
  mounted() {
    this.loadCategory();
    this.$router.push("/principal");
  },
};
</script>
